export const BASE_URL = 'https://esnaduni-api.midadworld.com';
export const BYTE_RANGE_BASE_URL = BASE_URL + '/api/file-manager/stream';

export const INNER_VERSION = '1.21.2';
export const VERSION = '3.7.2';